module.exports = __webpack_public_path__ + "img/swiperLeft.d54a416b.svg";